import React from "react"
import { SensaiComponentFeatureQuote } from "../../../gql/generated/graphql"
import { Box, height } from "@mui/system"
import { Grid, Typography } from "@mui/material"
import { GatsbyImage } from "gatsby-plugin-image"
import theme from "../../../material-ui/theme"
import Quote, { QuoteMark } from "../../ui/Quote"

const QuoteFeature = ({
  feature,
}: {
  feature: SensaiComponentFeatureQuote
}) => {
  const {
    id,
    quote,
    authorName,
    authorDescription,
    image,
    featureStyle,
    video,
  } = feature
  const dark = featureStyle?.style === "dark"
  return (
    <Box
      sx={{
        padding: "3rem",
        borderRadius: "1rem",
        position: "relative",
        display: "flex",
        flexDirection: "column",
        backgroundColor: dark ? "var(--color-dark-blue)" : "var(--color-white)",
        ...(dark ? { color: "white" } : {}),
      }}
    >
      <Grid
        container
        spacing={5}
        alignItems={"stretch"}
        justifyContent={"center"}
      >
        <Grid item sm={12} md={4}>
          <Box
            sx={{
              position: "relative",
              display: "flex",
              flexDirection: "column",
              height: "100%",
              width: "100%",
            }}
          >
            <Box sx={{ height: "30px", position: "relative" }}>
              <QuoteMark noReduce={true}>&ldquo;</QuoteMark>
            </Box>
            {quote && (
              <p
                style={{
                  zIndex: "2",
                  fontSize: "1.2rem",
                  marginTop: "1.5rem",
                  lineHeight: "1.8rem",
                }}
              >
                {quote}
              </p>
            )}
            <Box
              sx={{
                marginTop: "auto",
              }}
            >
              {authorName && (
                <Typography
                  variant="h5"
                  color={dark ? "white" : "var(--color-grey-6)"}
                  fontSize={"1rem"}
                  lineHeight={"1.4rem"}
                  fontWeight={600}
                >
                  {authorName}
                </Typography>
              )}
              {authorDescription && (
                <Typography
                  variant="h5"
                  color={"var(--color-teal)"}
                  fontSize={"1rem"}
                  lineHeight={"1.2rem"}
                  fontWeight={400}
                  marginTop={"0.5rem"}
                >
                  {authorDescription}
                </Typography>
              )}
            </Box>
          </Box>
        </Grid>
        <Grid item sm={12} md={8}>
          <Box
            data-aos="flip-up"
            sx={{
              marginTop: "auto",
            }}
          >
            {image && (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  height: "550px",
                  [theme.breakpoints.down("sm")]: {
                    height: "300px",
                  },
                  [theme.breakpoints.down("md")]: {
                    height: "400px",
                  },
                }}
              >
                <GatsbyImage
                  image={image.imageFile?.childImageSharp?.gatsbyImageData}
                  style={{
                    borderRadius: "1rem",
                  }}
                  objectFit="cover"
                  objectPosition="50% 50%"
                  alt={image.alternativeText ?? ""}
                />
              </Box>
            )}
          </Box>
        </Grid>
      </Grid>
    </Box>
  )
}

export default QuoteFeature
